import React from 'react';

import { useI18nContext } from '@ecg-internal/js-react-i18n';

import { CardCollection, SecondaryButton, Title2 } from '@hz-design-system/web-ui';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import TListing from '../../types/TListing';
import TAttribute from '../../types/TAttribute';
import TCategory from '../../types/TCategory';

import { getLrpUrlWithQuery } from '../../utils/url';

import Listing from '../../components/Listing';

import HeroHeader from './components/HeroHeader';
import SearchForm from './components/SearchForm';
import Title from './components/Title';
import './PopularKeywordApp.scss';

type TAppState = {
  keyword: string;
  searchResults: {
    subCategories: Array<TCategory>;
    listings: Array<TListing>;
    lrpBaseUrl: string;
    query: string;
    conditionFacet?: {
      attributeGroup?: Array<TAttribute>;
    };
  };
};

type TEnvironment = {
  staticBaseUrl: string;
  baseUrl: string;
  xsrfToken: string;
};

type TPopularKeywordApp = {
  appState: TAppState;
  environment: TEnvironment;
};

const PopularKeywordApp = ({ appState, environment }: TPopularKeywordApp) => {
  const {
    keyword,
    searchResults: { subCategories, listings, lrpBaseUrl, conditionFacet = {}, query },
  } = appState;

  const { t } = useI18nContext();
  const lrpUrlWithQuery = getLrpUrlWithQuery(lrpBaseUrl, query);

  return (
    <EnvironmentProvider value={environment}>
      <HeroHeader>
        <Title keyword={keyword} />

        <SearchForm
          categories={subCategories}
          conditions={conditionFacet?.attributeGroup}
          lrpBaseUrl={lrpBaseUrl}
          query={query}
        />
      </HeroHeader>

      <div className="hz-Page-content">
        <div className="subTitle">
          <Title2>{t(`popularKeywords.listings.recentlyAdded.${keyword}`)}</Title2>
        </div>
        <CardCollection kind="grid">
          {listings.map((listing) => (
            <Listing listing={listing} key={listing.itemId} />
          ))}
        </CardCollection>
        <div className="showAllButtonWrapper">
          <SecondaryButton as="a" href={lrpUrlWithQuery}>
            {t('popularKeywords.listings.showAll')}
          </SecondaryButton>
        </div>
      </div>
    </EnvironmentProvider>
  );
};

export default PopularKeywordApp;
